"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItemContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Accordion = require("./Accordion.styled");

var _hocs = require("../hocs");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AccordionItemContent = function AccordionItemContent(_ref) {
  var theRef = _ref.theRef,
      children = _ref.children;
  return _react.default.createElement(_Accordion.ItemContentContainer, {
    ref: theRef
  }, children);
};

var accordionItemContentWithRef = (0, _hocs.withForwardRef)(AccordionItemContent);
exports.AccordionItemContent = accordionItemContentWithRef;
AccordionItemContent.defaultProps = {
  show: false
};
AccordionItemContent.propTypes = {
  show: _propTypes.default.bool
};